import { PERMISSIONS } from '../usersPermissions/usersPermissionsCadernoLPMA';

export const isRequester = (roles: string[]): boolean => {
    return (roles ?? []).some(role =>
        role === PERMISSIONS.Requisitante
        || role === PERMISSIONS.RequisitanteWrite
        || role === PERMISSIONS.RequisitanteRead
    );
};

/** @deprecated Use isRequester — perfil único sem read/write. */
export const isRequesterReader = (roles: string[]): boolean => isRequester(roles);

/** @deprecated Use isRequester — perfil único sem read/write. */
export const isRequesterWriter = (roles: string[]): boolean => isRequester(roles);
